// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IdeaRowOut } from './ideaRowOut.zod.ts';

export const IdeaListOut = zod.object({
  "counts": zod.record(zod.string(), zod.int()),
  "ideas": zod.array(IdeaRowOut),
  "page": zod.int(),
  "page_size": zod.int(),
  "total": zod.int(),
  "verdict_counts": zod.record(zod.string(), zod.int())
});

export type IdeaListOut = zod.input<typeof IdeaListOut>;
export type IdeaListOutOutput = zod.output<typeof IdeaListOut>;
